import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class SharingService {
  private sharingObject: any;
  private sharingEntireObject: any;
  constructor() { }

  get sharingEntirecValue() {
    return this.sharingEntireObject
  }

  set sharingEntirecValue(obj) {
    this.sharingEntireObject = obj;
  }

  get sharingValue() {
    return this.sharingObject
  }

  set sharingValue(obj) {
    this.sharingObject = obj;
  }
  setFormsDeclarationData(obj){

    this.sharingEntireObject = obj;

  }

  getFormsDeclarationData() {
    return this.sharingEntireObject;
  }
  setFormsData(obj){

    this.sharingObject = obj;

  }

  getFormsData() {
    return this.sharingObject;
  }
  createAuthorizationHeader() {
     return new HttpHeaders({ 
          'Content-Type': 'application/json',
          'Authorization': "bearer" + sessionStorage.getItem("token") 
          })
    ;
  }
}
